import LoginPage from "./LoginPage";

export default function ParentLoginPage() {
  return <LoginPage forcedOriginalPath="/parent" forcedMode="parent" />;
}
